import React from 'react';
import VulnerableAgreementForm from '../VulnerebleAgreementForm';
import VulnerableAgreementFormEdit from '../VulnerebleAgreementFormEdit';
import VulnerableAgreementFormCal from '../VulnerebleAgreementFormCal';
import Loading from "../../../../common/components/Loading";
import VulnerableAgreementFormContextProvider, { VulnerableAgreementFormContext, ACTIONS }  from '../../context/VulnerableAgreementContextProvider';
import { ApplicationPropertiesContext } from "../../../../common/context/ApplicationPropertiesProvider";
import { decode_utf8 } from '../../../../common/utils/utilsFunc';


function VulnerableAgreementFormController({props}) {
    const [state, dispatch] = React.useContext(VulnerableAgreementFormContext)
    const properties = React.useContext(ApplicationPropertiesContext)
    const [loading, setLoading] = React.useState(false)
    const [webContentResponse, setwebContentResponse] = React.useState('')
    const [idClient, setIdClient] = React.useState('')
    const [detailClientJson, setDetailClientJson] = React.useState([])
    const [jsonForm, setJsonForm] = React.useState(null)
    const [resetForm, setResetForm] = React.useState(false)
    const [optionsRegion, setOptionsRegion] = React.useState([{
        label: "Selecione una opción",
        value: ""
    }])
    const [optionsCuetas, setOptionsCuetas] = React.useState([{label: "Selecione una opción",value: ""}]);
    const [optionsFact, setOptionsFact] = React.useState([{label: "Selecione una opción",value: ""},{label: "Sí",value: 1},{label: "No",value: 0}]);
    const [checkModifFormCovid, setCheckModifFormCovid] = React.useState(null);
    const [modificationFormCovidData, setModificationFormCovidData] = React.useState(null);
    const [cuentaContratoCuota, setCuentaContratoCuota] = React.useState(null);
    const [currentPage, setCurrentPage] = React.useState(null);

    React.useEffect(() => {
        dispatch({
          payload: true,
          type: ACTIONS.SET_LOAD_PAGE,
        });
        let arAux = [{label: "Selecione una opción",value: ""}];
        for (let index = 1; index <= Number(properties.cantidad_cuotas_mensuales); index++) {
          arAux.push({label:index.toString(),value:index})
        }
        setOptionsCuetas(arAux);      
    }, []);
    
    React.useEffect(() => {
      if(idClient){
        setLoading(true)
      }
      setDetailClientJson([])
      dispatch({
        type:ACTIONS.SET_IDCLIENT,
        payload: idClient
      })
      setIdClient("")
    }, [idClient]);

    React.useEffect(() => {
        if(state.detailClient){
          setLoading(false)
          if(state.detailClient?.ConsultarDetalleCtaCtoResponse?.RETORNO.RETURN || state.detailClient?.ConsultarDetalleCtaCtoResponse?.RETORNO.RETURN === 0) {
            if(state.detailClient?.ConsultarDetalleCtaCtoResponse?.RETORNO.RETURN === 0){
              setDetailClientJson(state.detailClient?.ConsultarDetalleCtaCtoResponse?.ITEM)
            } else {
              setDetailClientJson([]);
              props.setGlobalAlert(state.detailClient?.ConsultarDetalleCtaCtoResponse?.RETORNO?.TEXTO_RETURN ? state.detailClient?.ConsultarDetalleCtaCtoResponse?.RETORNO?.TEXTO_RETURN : decode_utf8(props.text_fetch_error) ,"warning", true, "Advertencia");
            }
          } else {
            setDetailClientJson([]);
            props.setGlobalAlert(decode_utf8(props.text_fetch_error),"warning", true, "Advertencia");
          }
        }
    }, [state.detailClient]);

    React.useEffect(() => {
      if(cuentaContratoCuota) {
        setLoading(true);
        dispatch({
          type:ACTIONS.SET_CALCULA_TU_CUOTA,
          payload: cuentaContratoCuota
        })
      }
    },[cuentaContratoCuota]);

    React.useEffect(() => {
      if(checkModifFormCovid) {
        setLoading(true);
        dispatch({
          type:ACTIONS.SET_MODIFICATION_FORM_COVID,
          payload: checkModifFormCovid
        })
      }
    },[checkModifFormCovid]);

    React.useEffect(() => {
      if(modificationFormCovidData) {
        setLoading(true);
        dispatch({
          type:ACTIONS.SET_MODIFICATION_FORM_COVID_DATA,
          payload: modificationFormCovidData
        })
      }
    },[modificationFormCovidData]);

    React.useEffect(() => {
      if(jsonForm) {
        setLoading(true);
        dispatch({
          type:ACTIONS.SET_FORM_DATA,
          payload: jsonForm
        })
      }
    },[jsonForm]);


    React.useEffect(() => {
      setLoading(false);
      const objResponse = state.formDataResponse?.data;

      if(objResponse) {
        if(objResponse?.code === 0) {
          props.setGlobalAlert(decode_utf8(objResponse?.message),"success", true, "Confirmación");
          setResetForm(true);
        } else {
          props.setGlobalAlert(decode_utf8(objResponse?.message),"warning", true, "Advertencia");
        }
      }
      
      
      
    },[state.formDataResponse])


  return (
      <>
        <div className="bg-white">
            <nav className="container-table pl-0 pr-0 pt-0">
                <ul className="nav nav-tabs nav-justified" id="myTab" role="tablist">
                    <li className="nav-item">
                        <a onClick={() => setCurrentPage("sendForm")} className="nav-link active" id="send-form" data-toggle="tab" href="#sendForm" role="tab" aria-controls="sendForm" aria-selected="true" data-lineheight="30" data-fontsize="18" >{decode_utf8(props.title_tab_1_vulnereble_agreement)}</a>
                    </li>

                    <li className="nav-item">
                        <a onClick={() => setCurrentPage("updateForm")} className="nav-link" id="update-form" data-toggle="tab" href="#updateForm" role="tab" aria-controls="updateForm" aria-selected="false" data-lineheight="30" data-fontsize="18" >{decode_utf8(props.title_tab_2_vulnereble_agreement)}</a>
                    </li>
                    <li className="nav-item">
                        <a onClick={() => setCurrentPage("calQuota")} className="nav-link" id="cal-quota" data-toggle="tab" href="#calQuota" role="tab" aria-controls="calQuota" aria-selected="false" data-lineheight="30" data-fontsize="18" >{decode_utf8(props.title_tab_3_vulnereble_agreement)}</a>
                    </li>
                </ul>
            </nav>
            <div className="tab-content" id="myTabContent">
                <div className="tab-pane fade show active" id="sendForm" role="tabpanel" aria-labelledby="send-form">
                  <VulnerableAgreementForm props={{...props, state, idClient, setIdClient, optionsCuetas, optionsFact, detailClientJson, loading, setLoading, setJsonForm, resetForm, setResetForm, setDetailClientJson}}/>
                </div>
                <div class="tab-pane fade" id="updateForm" role="tabpanel" aria-labelledby="update-form">
                  <VulnerableAgreementFormEdit props={{...props, state, idClient, setIdClient, optionsCuetas, optionsRegion, setOptionsRegion, detailClientJson, loading, setLoading, setJsonForm, resetForm, setResetForm, setDetailClientJson, checkModifFormCovid, setCheckModifFormCovid, modificationFormCovidData, setModificationFormCovidData}}/>
                </div>
                <div class="tab-pane fade" id="calQuota" role="tabpanel" aria-labelledby="cal-quota">
                  <VulnerableAgreementFormCal props={{...props, state, idClient, setIdClient, optionsCuetas, optionsRegion, setOptionsRegion, detailClientJson, loading, setLoading, setJsonForm, resetForm, setResetForm, setDetailClientJson, properties, cuentaContratoCuota, setCuentaContratoCuota, currentPage}}/>
                </div>
            </div>
        </div>
        {loading && <Loading />}
        
      </>
  )
}

const VulnerableAgreementFormControllerWithProvider = ({
    props
}) => ( 
<VulnerableAgreementFormContextProvider>
    <VulnerableAgreementFormController
      props={props}
    />
</VulnerableAgreementFormContextProvider>
)

export default VulnerableAgreementFormControllerWithProvider; 